export const BI_EVENT_TEXT_MAX_SIZE = 20;

export const BISources = {
  PLATFORM: 'platform',
  TORCH: 'TORCH',
} as const;

export const BIEvents = {
  PAGE_VIEW: '$pageview',
  CLICK: 'click',
  TAB: 'tab',
  LOGOUT: 'logout',
} as const;

export const BI_EVENT_TYPES = new Set<string>(Object.values(BIEvents));

export const BI_MASK_DATA_ATTRIBUTE = 'data-bi-mask';
export const BI_UNMASK_DATA_ATTRIBUTE = 'data-bi-unmask';

export const BI_MASK_SELECTORS_STRING = [`[${BI_MASK_DATA_ATTRIBUTE}]`].join(
  ',',
);

export const BI_UNMASK_SELECTORS_STRING = [
  `[${BI_UNMASK_DATA_ATTRIBUTE}]`,
  '.ag-header',
].join(',');
